export default "__VITE_ASSET__cc93de3c__"